// The in-app path to return to after sign-in. Only same-origin absolute paths are
// allowed: "//host" and "/\host" are protocol-relative URLs in browsers, so they fall back to "/".
export function safeReturnTo(value) {
  if (typeof value !== 'string' || !value.startsWith('/')) return '/';
  if (value.startsWith('//') || value.startsWith('/\\')) return '/';
  return value;
}
